import Vue from 'vue'
/**
 * 全局组件自动注册
 */
export default function (app: typeof Vue) {
  const requireComponent = require.context(
    // 其组件目录的相对路径
    './components/global',
    // 是否查询其子目录
    false,
    // 匹配基础组件文件名的正则表达式
    /[A-Z]\w+\.(vue|js)$/,
  )

  requireComponent.keys().forEach((fileName) => {
    // 获取组件配置
    const componentConfig = requireComponent(fileName)

    // 全局注册组件
    app.component(
      componentConfig.default.name,
      // 如果这个组件选项是通过 `export default` 导出的，
      // 那么就会优先使用 `.default`，
      // 否则回退到使用模块的根。
      componentConfig.default || componentConfig,
    )
  })
}
